import script from "./VertexProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./VertexProducts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__